import React from 'react';
import { Table } from '../TradeCurrency/Table';
import { Column } from './Columns';
// import FitButtons from "../Components/FitButton";

import ModalHistoryDetails from './ModalHistoryDetails';
import Modal from '../Components/Modal';
import { ModalEditHistory } from './ModalEditHistory';

export const HistoryTable = ({ content }) => {
  const {
    historyDataArray,
    transactionHistoryDetails,
    handleOpenandCloseModal,
    openModal,
  } = content;

  // const historyDataArray = HistoryTableData.map((data) => {
  //   return {
  //     date: data.date,
  //     currency: data.currency,
  //     amount: data.amount,
  //     rate: data.rate,
  //     total: data.total,
  //     payment: data.payment,
  //     action: (
  //       <FitButtons
  //         details="View Details"
  //         color="blue"
  //         icon={false}
  //         onClick={() => handleGetIdandShowDetails(data.id)}
  //       />
  //     ),
  //   };
  // });

  // const handleGetIdandShowDetails = (id) => {
  //   for (let i = 0; i < HistoryTableData.length; i++) {
  //     if (HistoryTableData[i].id === id) {
  //       setTransactionDetails(HistoryTableData[i]);
  //     }
  //   }
  //   setIsShowingDetails(!isShowingDetails);
  //   console.log(transactionDetails, id, isShowingDetails);
  // };

  return (
    <div className='flex flex-col gap-6'>
      {historyDataArray?.length > 0 && (
        <Table
          columns={Column}
          data={historyDataArray?.length > 0 ? historyDataArray : []}
          showControls={true}
        />
      )}
      {/* {historyDataArray?.length === 0 && (
        <Table columns={Column} data={empty} />
      )} */}
      <Modal open={openModal === 'transactionHistoryDetails'}>
        <ModalHistoryDetails
          content={{ transactionHistoryDetails, handleOpenandCloseModal }}
        />
      </Modal>
      <Modal open={openModal === 'transactionEditHistoryDetails'}>
        <ModalEditHistory
          content={{ transactionHistoryDetails, handleOpenandCloseModal }}
        />
      </Modal>
    </div>
  );
};
